import { apiCall } from "../service/api-service";

export const fetchStateTaxFlags = async (stateId) => {
  if (stateId === null || stateId === undefined || stateId === "") {
    return { igst: false, cgst: false, sgst: false };
  }

  if (Number(stateId) === 0) {
    return { igst: false, cgst: false, sgst: false };
  }

  try {
    const response = await apiCall("POST", "check_state_tax", {
      state_id: stateId,
    });

    if (response?.data?.success === true) {
      return {
        igst: response.data.data?.igst ?? false,
        cgst: response.data.data?.cgst ?? false,
        sgst: response.data.data?.sgst ?? false,
      };
    }
  } catch (error) {
    // Ignore state-tax fetch errors
  }

  return { igst: false, cgst: false, sgst: false };
};

export const applyStateTaxFlags = async (stateId, setters) => {
  if(!setters || typeof setters !== "object") {
    return;
  }
  const flags = await fetchStateTaxFlags(stateId);
  if (setters.setIsIgst) setters.setIsIgst(flags.igst);
  if (setters.setIsCgst) setters.setIsCgst(flags.cgst);
  if (setters.setIsSgst) setters.setIsSgst(flags.sgst);
};
